import { IState } from '../../store';
import { IComparisonNotification } from '../../types/comparisonNotification';

export const getOffersComparisonNotification = (state: IState): IComparisonNotification | null => {
  return state.comparisonNotification;
};
